import React, { useState, useEffect } from 'react';
import { Box, Fade, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import Logo from '../../assets/Design sem nome (7).png';

const SplashContainer = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
  zIndex: 9999,
});

const LogoImage = styled('img')(({ theme }) => ({
  height: 'auto',
  maxWidth: '90%',
  maxHeight: '70%',
  // Responsivo para diferentes tamanhos de tela
  [theme.breakpoints.down('sm')]: {
    width: '280px', // Mobile pequeno
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: '320px', // Mobile médio
  },
  [theme.breakpoints.up('md')]: {
    width: '350px', // Desktop
  },
}));

interface SplashScreenProps {
  onFinish: () => void;
  duration?: number;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ 
  onFinish, 
  duration = 3000 
}) => {
  const [show, setShow] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      setTimeout(onFinish, 500); // Aguarda a animação de fade out
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [duration, onFinish]);

  return (
    <Fade in={show} timeout={500}>
      <SplashContainer>
        <LogoImage 
          src={Logo} 
          alt="GRUPO SUPPORT Life"
          onError={(e) => {
            console.error('Erro ao carregar logo da splash screen');
            e.currentTarget.style.display = 'none';
          }}
        />
      </SplashContainer>
    </Fade>
  );
};

export default SplashScreen; 